import { Container, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import Select from "../../../components/Select/Select";
import TopBar from "../../../components/TopBar/TopBar";
import {
  approveStockAdjustment,
  approveStockIssueRequest,
  deleteReturnPaymentById,
  getClinicStocksWoLoader,
  getReturnPaymentById,
  getServicesWoLoader,
  lockUnlockAppointmentById,
  updateBalanceDueAndStatusByPaymentId,
  updateClinicServiceStatusById,
  updateClinicServiceVariantApproved,
  updateClinicStockBatchApproved,
  updateClinicStockStatusById,
  updatePaymentReturnedWoLoader,
  updatePurchaseOrderCreditSave,
} from "../../../redux/reducers/clinicSlice";
import {
  approveApprovalRequest,
  getApprovalRules,
  getApprovals,
  rejectApprovalRequest,
} from "../../../redux/reducers/globalSettingsSlice";
import { updateReturnOnBillingItems } from "../../../redux/reducers/paymentSlice";
import { showSnackBar } from "../../../redux/reducers/snackSlice";
import {
  getPaymentStatusAndRefund,
  getRefundValuesNew,
  getSessionData,
  roundWithSignedDiff,
} from "../../../util/function";
import {
  patchMandateSession,
  readMandateSession,
} from "../../../util/mandateSessionStorage";
import ReportTable from "../Reports/ReportTable";
import "./AppointmentsTab.css";

const filterRequestTypeOptions = [
  { name: "All selected", value: "All selected" },
  { name: "Refund/Return", value: "REFUND_RETURN" },
  { name: "Item Creation", value: "ITEM_CREATION" },
  { name: "Variant Creation", value: "VARIANT_CREATION" },
  { name: "Batch Creation", value: "BATCH_CREATION" },
  { name: "Stock Transfer", value: "STOCK_TRANSFER" },
  { name: "Stock Adjustment", value: "STOCK_ADJUSTMENT" },
  { name: "Edit Consult", value: "EDIT_CONSULT" },
  { name: "Purchase Order", value: "PURCHASE_ORDER" },
];

const FILTER_TYPE_TO_REQUEST_TYPES = {
  REFUND_RETURN: ["REFUND", "RETURN"],
  ITEM_CREATION: ["SERVICE_NEW", "INVENTORY_NEW"],
  VARIANT_CREATION: ["SERVICE_NEW_VARIANT"],
  BATCH_CREATION: ["INVENTORY_NEW_BATCH"],
  STOCK_TRANSFER: [
    "INTERNAL_TRANSFER",
    "EXTERNAL_TRANSFER",
    "INTERNAL_TRASFER",
    "EXTERNAL_TRASFER",
  ],
  STOCK_ADJUSTMENT: ["COUNT_CORRECTION"],
  EDIT_CONSULT: ["EDIT_CONSULT"],
  PURCHASE_ORDER: ["PURCHASE_ORDER"],
};

const filterRequestStatusOptions = [
  { name: "All selected", value: "All selected" },
  { name: "Pending", value: "Pending" },
  { name: "Approved", value: "Approved" },
  { name: "Rejected", value: "Rejected" },
];

const tableHeaders = [
  // "priority",
  "type",
  "requester",
  "summary",
  "status",
  "approvalStep",
  "submitted",
  "approvedBy",
  "actions",
];

const requestTypeOptions = [
  { name: "— Select type —", value: "" },
  { name: "Leave", value: "Leave" },
  { name: "Refund", value: "Refund" },
  { name: "Write-off", value: "Write-off" },
  { name: "Discount", value: "Discount" },
  { name: "Return", value: "Return" },
  { name: "Item Creation", value: "Item Creation" },
  { name: "Stock Transfer", value: "Stock Transfer" },
  { name: "Stock Adjustment", value: "Stock Adjustment" },
  { name: "Other", value: "Other" },
];

const priorityOptions = [
  { name: "Low", value: "Low" },
  { name: "Medium", value: "Medium" },
  { name: "High", value: "High" },
  { name: "Urgent", value: "Urgent" },
];

const REQUEST_TYPE_LABELS = {
  SERVICE_NEW: "Item Creation",
  SERVICE_NEW_VARIANT: "Variant Creation",
  INVENTORY_NEW: "Item Creation",
  INVENTORY_NEW_BATCH: "Batch Creation",
  REFUND: "Refund",
  WRITE_OFF: "Write-off",
  DISCOUNT_PERCENT: "Discount",
  INTERNAL_TRANSFER: "Stock Transfer",
  EXTERNAL_TRANSFER: "Stock Transfer",
  INTERNAL_TRASFER: "Stock Transfer",
  EXTERNAL_TRASFER: "Stock Transfer",
  COUNT_CORRECTION: "Stock Adjustment",
  EDIT_CONSULT: "Edit Consult",
  PURCHASE_ORDER: "Purchase Order",
};

const COUNT_CORRECTION_TYPE = "COUNT_CORRECTION";
const STOCK_TRANSFER_TYPES = [
  "INTERNAL_TRANSFER",
  "EXTERNAL_TRANSFER",
  "INTERNAL_TRASFER",
  "EXTERNAL_TRASFER",
];
const REFUND_REQUEST_TYPES = ["REFUND", "RETURN"];

const REQUEST_TYPE_RULE_KEYS = {
  REFUND: ["REFUND", "RETURN"],
  RETURN: ["REFUND", "RETURN"],
  WRITE_OFF: ["WRITE_OFF"],
  DISCOUNT_PERCENT: ["DISCOUNT_PERCENT"],
  SERVICE_NEW: ["SERVICE_NEW"],
  SERVICE_NEW_VARIANT: ["SERVICE_NEW_VARIANT"],
  INVENTORY_NEW: ["INVENTORY_NEW"],
  INVENTORY_NEW_BATCH: ["INVENTORY_NEW_BATCH"],
  INTERNAL_TRANSFER: ["INTERNAL_TRANSFER", "INTERNAL_TRASFER"],
  INTERNAL_TRASFER: ["INTERNAL_TRANSFER", "INTERNAL_TRASFER"],
  EXTERNAL_TRANSFER: ["EXTERNAL_TRANSFER", "EXTERNAL_TRASFER"],
  EXTERNAL_TRASFER: ["EXTERNAL_TRANSFER", "EXTERNAL_TRASFER"],
  COUNT_CORRECTION: ["COUNT_CORRECTION"],
  PURCHASE_ORDER: ["PURCHASE_ORDER"],
};

const ROLE_TO_USER_TYPES = {
  FRONT_DESK: ["ROLE_RECEPTION"],
  BILLING: ["ROLE_BILLING"],
  INVENTORY_MANAGER: ["ROLE_INVENTORY"],
  BRANCH_MANAGER: ["ROLE_CLINICADMIN"], //ROLE_CLINIC
  CLINIC_OWNER: ["ROLE_CLINIC"], //ROLE_ADMIN
  ROLE_CLINICSUPERADMIN: ["ROLE_CLINICSUPERADMIN"],
};

const toIdList = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) =>
        Number(
          typeof item === "object"
            ? (item?.value ?? item?.id ?? item?.userId ?? item?.doctorId)
            : item,
        ),
      )
      .filter((id) => Number.isFinite(id) && id > 0);
  }
  if (typeof value === "string" && value.trim()) {
    try {
      return toIdList(JSON.parse(value));
    } catch {
      return value
        .split(",")
        .map((v) => Number(v.trim()))
        .filter((id) => Number.isFinite(id) && id > 0);
    }
  }
  return [];
};

const toRoleCodeList = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) =>
        String(
          typeof item === "object" ? (item?.code ?? item?.value ?? item) : item,
        ).trim(),
      )
      .filter(Boolean);
  }
  if (typeof value === "string" && value.trim()) {
    try {
      return toRoleCodeList(JSON.parse(value));
    } catch {
      return value
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
    }
  }
  return [];
};

const getSessionClinic = () => {
  try {
    return readMandateSession()?.clinic ?? getSessionData()?.clinic ?? {};
  } catch {
    return {};
  }
};

/** EDIT_CONSULT: CLINIC_OWNER matches by role; other roles use selected users when set. */
const canApproveEditConsult = (profile) => {
  const clinic = getSessionClinic();
  const editRoles = toRoleCodeList(
    clinic?.editConsultationRoles ?? clinic?.editConsultRoles,
  );
  const editUsers = toIdList(
    clinic?.editConsultationUsers ?? clinic?.editConsultUsers,
  );
  if (!editRoles.length && !editUsers.length) return false;

  const userRoleNames = getCurrentUserRoleNames(profile).map((name) =>
    String(name).trim(),
  );
  const matchesRole = (code) => {
    const allowedTypes = (ROLE_TO_USER_TYPES[code] || [code]).map((type) =>
      String(type).trim(),
    );
    return allowedTypes.some(
      (type) =>
        userRoleNames.includes(type) ||
        userRoleNames.includes(String(code).trim()),
    );
  };
  // Clinic Owner and Super Admin have no person picker — role match is enough
  if (
    ["CLINIC_OWNER", "ROLE_CLINICSUPERADMIN"]?.some(
      (code) => editRoles?.includes(code) && matchesRole(code),
    )
  ) {
    return true;
  }

  const currentUserId = Number(
    profile?.id ?? profile?.doctorId ?? profile?.userId,
  );

  // Users selected under other roles (e.g. Practice Manager) → check that list
  if (editUsers.length > 0) {
    return Number.isFinite(currentUserId) && editUsers.includes(currentUserId);
  }

  // No specific users — any selected role can approve
  return editRoles.some((code) => matchesRole(code));
};

const getCurrentUserRoleNames = (profile) => {
  const names = new Set();
  const storedRole = localStorage.getItem("role");
  if (storedRole) names.add(storedRole);
  if (profile?.role) names.add(profile.role);
  if (profile?.userRole) names.add(profile.userRole);
  const types = profile?.userType || profile?.roles || profile?.roleList || [];
  if (Array.isArray(types)) {
    types.forEach((role) => {
      const name =
        typeof role === "string" ? role : role?.name || role?.authority;
      if (name) names.add(name);
    });
  }
  return [...names].filter(Boolean);
};

const userMatchesApprovalRule = (rule, profile) => {
  if (!rule) return false;
  const ruleRoles = Array.isArray(rule?.roles)
    ? rule.roles.filter(Boolean)
    : [];
  const ruleUserIds = (Array.isArray(rule?.userIds) ? rule.userIds : [])
    .map((id) => Number(id))
    .filter((id) => !Number.isNaN(id));

  const userRoleNames = getCurrentUserRoleNames(profile).map((name) =>
    String(name).trim(),
  );
  const roleMatched =
    ruleRoles.length === 0
      ? false
      : ruleRoles.some((code) => {
          const allowedTypes = (ROLE_TO_USER_TYPES[code] || [code]).map(
            (type) => String(type).trim(),
          );
          return allowedTypes.some(
            (type) =>
              userRoleNames.includes(type) ||
              userRoleNames.includes(String(code).trim()),
          );
        });

  const currentUserId = Number(
    profile?.id ?? profile?.doctorId ?? profile?.userId,
  );
  const userIdMatched =
    ruleUserIds.length > 0 &&
    !Number.isNaN(currentUserId) &&
    ruleUserIds.includes(currentUserId);

  // Roles only (no userIds) → role match is enough
  if (!ruleUserIds.length) return roleMatched;

  // Specific people selected under roles:
  // - matching role can still approve (e.g. CLINIC_OWNER → ROLE_CLINIC)
  // - OR current userId is in the selected userIds list
  return roleMatched || userIdMatched;
};

const getMatchedRuleForRequest = (approvalRules, requestType, amount) => {
  const ruleKeys = REQUEST_TYPE_RULE_KEYS[requestType] || [];
  if (!ruleKeys.length) return null;

  const rulesMap = approvalRules?.rules ?? approvalRules;
  if (!rulesMap || typeof rulesMap !== "object") return null;

  const config = ruleKeys.map((key) => rulesMap[key]).find(Boolean) ?? null;
  if (!config) return null;
  if (config?.autoApproval) return null;

  const rules = Array.isArray(config?.rules)
    ? config.rules
    : Array.isArray(config)
      ? config
      : [];
  if (!rules.length) return null;

  // Amount tiers only when both bounds are usable numbers.
  // Inventory rules often use minValue: 0, maxValue: null (open-ended).
  const hasClosedAmountTiers = rules.some(
    (rule) =>
      rule?.minValue != null &&
      rule?.maxValue != null &&
      !Number.isNaN(Number(rule.minValue)) &&
      !Number.isNaN(Number(rule.maxValue)),
  );

  if (!hasClosedAmountTiers) return rules[0] ?? null;

  const value = Math.abs(Number(amount ?? 0));
  return (
    rules.find((rule) => {
      const min = rule?.minValue == null ? 0 : Number(rule.minValue);
      const max =
        rule?.maxValue == null
          ? Number.POSITIVE_INFINITY
          : Number(rule.maxValue);
      return (
        !Number.isNaN(min) && !Number.isNaN(max) && value >= min && value <= max
      );
    }) ??
    rules[0] ??
    null
  );
};

const getPriorityClass = (priority) => {
  const value = String(priority || "").toUpperCase();
  if (value === "URGENT") return "urgent";
  if (value === "HIGH") return "high";
  if (value === "LOW") return "medium";
  return "medium";
};

const getStatusClass = (status) => {
  const value = String(status || "").toLowerCase();
  if (value === "approved") return "approved";
  if (value === "rejected") return "rejected";
  if (value === "cancelled") return "rejected";
  return "pending";
};

const getRequesterInitials = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "—";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
};

const getSessionVets = () => {
  try {
    const list = readMandateSession()?.vets ?? getSessionData()?.vets ?? [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

const resolveUserDisplayName = (userId, vets = [], profile = null) => {
  if (userId == null || userId === "") return "";
  const raw = String(userId).trim();
  if (!raw) return "";
  // Already a name (non-numeric)
  if (Number.isNaN(Number(raw))) return raw;

  const matched = (Array.isArray(vets) ? vets : []).find(
    (vet) =>
      String(vet?.doctorId) === raw ||
      String(vet?.id) === raw ||
      String(vet?.userId) === raw,
  );
  if (matched?.name) return matched.name;

  if (
    profile &&
    (String(profile?.id) === raw ||
      String(profile?.doctorId) === raw ||
      String(profile?.userId) === raw)
  ) {
    return profile?.name || "";
  }
  return "";
};

const buildCreditReturnUpdateData = (bill) => {
  const returnList = (bill?.paymentReturnDeatils ?? bill?.paymentDetails ?? [])
    .filter((li) => Number(li?.returnQuantity) > 0)
    .map((li) => ({ ...li, oldReturnQuantity: li?.returnQuantity ?? 0 }));

  const paymentDetails = returnList.map((li) => {
    const qtyBase = Number(li?.oldReturnQuantity ?? li?.quantity ?? 0) || 1;
    const unitPrice = Number(Number(li?.total ?? li?.itemTotal ?? 0) / qtyBase);
    const unitTax = Number(Number(li?.tax ?? 0) / qtyBase);
    const safeUnitPrice = Number.isNaN(unitPrice) ? 0 : unitPrice;
    const safeUnitTax = Number.isNaN(unitTax) ? 0 : unitTax;
    const returnQty = Number(li?.returnQuantity ?? 0);
    const reqbj = {
      unitPrice: safeUnitPrice,
      unitTax: safeUnitTax,
      quantity: li?.quantity ?? 0,
      tax: Number(safeUnitTax * returnQty),
      price: li?.price,
      total: Number(safeUnitPrice * returnQty),
      returnQuantity: returnQty,
      name: li?.name,
    };
    if (li?.uomName) reqbj.uomName = li?.uomName;
    if (li?.uomId) reqbj.uomId = li?.uomId;
    if (li?.serviceId) reqbj.serviceId = li?.serviceId;
    if (li?.stockId) reqbj.stockId = li?.stockId;
    if (li?.batchId) reqbj.batchId = li?.batchId;
    if (li?.paymentDetailId) reqbj.paymentDetailId = li?.paymentDetailId;
    return reqbj;
  });

  const sumPaymentDetailsBy = (key) =>
    paymentDetails.reduce((acc, obj) => acc + Number(obj?.[key] ?? 0), 0);
  const amountPaid = Number(
    (bill?.petShopAmtPaid ?? 0) +
      (bill?.pharmacyAmtPaid ?? 0) +
      (bill?.amtPaid ?? 0),
  );
  const returnableAmount = Number(
    getRefundValuesNew(returnList, true)?.total ??
      sumPaymentDetailsBy("total") ??
      0,
  );
  const isPurchase = String(bill?.type ?? "").toLowerCase() === "purchase";
  const data = {
    paymentMode:
      amountPaid > 0 && returnableAmount > 0
        ? (bill?.paymentMode ?? null)
        : null,
    personInCharge: bill?.personInCharge ?? null,
    returnReason: bill?.returnReason,
    paymentDetails,
    creditSave: "credit",
    remarks: bill?.remarks ?? "",
    invoiceNumbers: bill?.invoiceNumbers ?? "",
    refundAmount: -Number(roundWithSignedDiff(returnableAmount)?.rounded),
    totalAmt: -Number(roundWithSignedDiff(returnableAmount)?.rounded),
    totalTax: -Number(sumPaymentDetailsBy("tax") ?? 0),
  };
  if (isPurchase) {
    data.type = "purchase";
  } else {
    data.type = "sales";
    data.returned = true;
  }
  return { data, amountPaid, returnableAmount };
};

const mapApprovalToRow = (approval, vets = [], profile = null) => {
  const statusText = approval?.status || "Pending";
  const isPending = String(statusText).toLowerCase() === "pending";
  const step = String(approval?.approvalStep || "");
  const stepParts = step
    ?.split("·")
    ?.map((part) => part.trim())
    ?.filter(Boolean);
  const updaterId = approval?.decidedBy || approval?.statusUpdatedBy || null;
  const updatedByName = resolveUserDisplayName(updaterId, vets, profile) || "—";

  return {
    id: approval?.approvalId,
    approvalId: approval?.approvalId,
    priorityText: String(approval?.priority || "MEDIUM").toUpperCase(),
    priorityClass: getPriorityClass(approval?.priority),
    type:
      REQUEST_TYPE_LABELS[approval?.requestType] ||
      approval?.requestType ||
      "Other",
    requestType: approval?.requestType,
    requester: approval?.requesterName || "—",
    requesterRole: approval?.requesterRole || "",
    requesterId: approval?.requesterId ?? null,
    requestedBy: approval?.requestedBy ?? null,
    summary: approval?.summary || "",
    statusText,
    statusClass: getStatusClass(statusText),
    stepPrimary: stepParts[1] || stepParts[0] || "—",
    stepSecondary: stepParts.length > 1 ? `(${stepParts[0]})` : "",
    approvalStep: step,
    submitted: approval?.submittedDate
      ? moment(approval.submittedDate).format("DD MMM YYYY, HH:mm")
      : approval?.createdDate
        ? moment(approval.createdDate).format("DD MMM YYYY, HH:mm")
        : "—",
    submittedDate: approval?.submittedDate || approval?.createdDate || null,
    category: isPending ? "pending" : "decided",
    isPending,
    amount: approval?.amount,
    referenceNo: approval?.referenceNo,
    referenceType: approval?.referenceType,
    referenceId: approval?.referenceId,
    stockId: approval?.stockId,
    serviceId: approval?.serviceId,
    issueId:
      approval?.issueId ??
      (approval?.referenceType === "STOCK_ISSUE"
        ? approval?.referenceId
        : null),
    adjustId:
      approval?.adjustId ??
      (approval?.referenceType === "STOCK_ADJUSTMENT"
        ? approval?.referenceId
        : null),
    returnId: approval?.returnId ?? null,
    paymentId:
      approval?.paymentId ??
      (approval?.referenceType === "PAYMENT" ? approval?.referenceId : null),
    appointmentId:
      approval?.appointmentId ??
      (approval?.referenceType === "APPOINTMENT"
        ? approval?.referenceId
        : null),
    petId: approval?.petId ?? null,
    doctorId: approval?.doctorId ?? null,
    userId: approval?.userId ?? null,
    petName: approval?.petName ?? "",
    customerName: approval?.customerName ?? approval?.userName ?? "",
    refundAmount: approval?.refundAmount ?? approval?.amount,
    invoiceNumber: approval?.invoiceNumber ?? "",
    invoiceDate: approval?.invoiceDate ?? "",
    supplierName: approval?.supplierName ?? "",
    editRequestFor: approval?.editRequestFor ?? "",
    quantity: approval?.quantity ?? null,
    noOfItems: approval?.noOfItems,
    rejectRemarks: approval?.rejectRemarks,
    decidedDate: approval?.decidedDate,
    decidedBy: approval?.decidedBy ?? null,
    statusUpdatedBy: approval?.statusUpdatedBy ?? null,
    approvedBy: updatedByName,
  };
};

const AppointmentsTab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const approvals = useSelector((state) => state?.globalSettings?.approvals);
  const approvalRules = useSelector(
    (state) => state?.globalSettings?.approvalRules,
  );
  const user = localStorage.getItem("user");
  const profile = user ? JSON.parse(user) : null;
  const canViewAllApprovals = getCurrentUserRoleNames(profile).some((role) =>
    ["ROLE_CLINIC", "ROLE_CLINICADMIN"].includes(String(role)),
  );
  const currentProfileId =
    profile?.id ?? profile?.doctorId ?? profile?.userId ?? null;

  const isOwnApprovalRequest = (item) => {
    if (currentProfileId == null) return false;
    const ownerId = item?.requesterId ?? item?.requestedBy ?? null;
    return ownerId != null && String(ownerId) === String(currentProfileId);
  };

  const [activeSubFilter, setActiveSubFilter] = useState("pending");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedViewItem, setSelectedViewItem] = useState(null);
  const [decisionModVsble, setDecisionModVsble] = useState(false);
  const [decisionType, setDecisionType] = useState(null);
  const [decisionItem, setDecisionItem] = useState(null);
  const [decisionRemarks, setDecisionRemarks] = useState("");
  const [decisionRemarksErr, setDecisionRemarksErr] = useState("");

  const [filterRequestType, setFilterRequestType] = useState("All selected");
  const [filterRequestStatus, setFilterRequestStatus] =
    useState("All selected");

  const [formValues, setFormValues] = useState({
    requestType: "",
    priority: "Medium",
    summary: "",
    notes: "",
  });
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    dispatch(getApprovals());
    dispatch(getApprovalRules({ silent: true }));
  }, [dispatch]);

  const canDecideRow = (row) => {
    if (!row || row.category !== "pending") return false;

    if (row.requestType === "EDIT_CONSULT") {
      return canApproveEditConsult(profile);
    }

    const ruleKeys = REQUEST_TYPE_RULE_KEYS[row.requestType];
    // Types without approval-rule config (e.g. Leave) stay actionable
    if (!ruleKeys?.length) return true;

    const matchedRule = getMatchedRuleForRequest(
      approvalRules,
      row.requestType,
      row.amount,
    );
    if (!matchedRule) return false;
    return userMatchesApprovalRule(matchedRule, profile);
  };

  const mappedRows = useMemo(() => {
    const vets = getSessionVets();
    return (Array.isArray(approvals) ? approvals : []).map((approval) =>
      mapApprovalToRow(approval, vets, profile),
    );
  }, [approvals, profile]);

  const visibleRows = useMemo(
    () =>
      mappedRows.filter(
        (row) => canViewAllApprovals || isOwnApprovalRequest(row),
      ),
    [mappedRows, canViewAllApprovals, currentProfileId],
  );

  const pendingCount = useMemo(
    () =>
      visibleRows.filter(
        (row) =>
          row.isPending ||
          row.category === "pending" ||
          String(row.statusText || "").toLowerCase() === "pending",
      ).length,
    [visibleRows],
  );

  const filteredRaw = visibleRows.filter((item) => {
    const isPendingStatus =
      item.isPending ||
      item.category === "pending" ||
      String(item.statusText || "").toLowerCase() === "pending";

    // Pending tab: only pending requests
    if (activeSubFilter === "pending") {
      if (!isPendingStatus) return false;
    }

    if (filterRequestType !== "All selected") {
      const allowedTypes =
        FILTER_TYPE_TO_REQUEST_TYPES[filterRequestType] || [];
      if (!allowedTypes.includes(item.requestType)) return false;
    }

    if (
      activeSubFilter === "my_requests" &&
      filterRequestStatus !== "All selected"
    ) {
      if (
        String(item.statusText || "").toLowerCase() !==
        String(filterRequestStatus).toLowerCase()
      ) {
        return false;
      }
    }

    return true;
  });

  const handleSubFilterChange = (next) => {
    setActiveSubFilter(next);
    if (next === "pending") {
      setFilterRequestStatus("All selected");
    }
  };
  const handleOpenModal = () => {
    setFormValues({
      requestType: "",
      priority: "Medium",
      summary: "",
      notes: "",
    });
    setFormErrors({});
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenViewModal = (row) => {
    setSelectedViewItem(row);
    setIsViewModalOpen(true);
  };

  const handleCloseViewModal = () => {
    setIsViewModalOpen(false);
    setSelectedViewItem(null);
  };

  const handleFormChange = (key, value) => {
    setFormValues((prev) => ({ ...prev, [key]: value }));
    if (formErrors[key]) {
      setFormErrors((prev) => ({ ...prev, [key]: "" }));
    }
  };

  const handleSubmitRequest = () => {
    const errors = {};
    if (!formValues.requestType)
      errors.requestType = "Request type is required";
    if (!formValues.summary) errors.summary = "Summary is required";

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    dispatch(
      showSnackBar({
        message: "Manual request creation is not available yet",
        type: "error",
      }),
    );
    setIsModalOpen(false);
  };

  const openDecisionModal = (row, type) => {
    setDecisionItem(row);
    setDecisionType(type);
    setDecisionRemarks(type === "approve" ? "Verified and approved" : "");
    setDecisionRemarksErr("");
    setDecisionModVsble(true);
  };

  const onCloseDecisionMod = () => {
    setDecisionModVsble(false);
    setDecisionType(null);
    setDecisionItem(null);
    setDecisionRemarks("");
    setDecisionRemarksErr("");
  };

  const completeApprovedRefund = async (item) => {
    const returnId = item?.returnId;
    if (!returnId) {
      dispatch(
        showSnackBar({
          message: "Return id not found",
          type: "error",
        }),
      );
      return false;
    }

    const returnRes = await dispatch(getReturnPaymentById(returnId));
    if (
      !getReturnPaymentById.fulfilled.match(returnRes) ||
      !returnRes?.payload
    ) {
      return false;
    }

    const bill = returnRes.payload;
    const { data, amountPaid, returnableAmount } =
      buildCreditReturnUpdateData(bill);
    if (!data?.paymentDetails?.length) {
      dispatch(
        showSnackBar({
          message: "Return details not found",
          type: "error",
        }),
      );
      return false;
    }

    const updateRes = await dispatch(
      updateReturnOnBillingItems({ data, id: returnId }),
    );
    if (
      !updateReturnOnBillingItems.fulfilled.match(updateRes) ||
      !updateRes?.payload
    ) {
      return false;
    }

    const paymentId = bill?.paymentId ?? item?.paymentId ?? item?.referenceId;
    const totalAmount = Number(bill?.totalAmt ?? 0);
    if (paymentId) {
      const payDetails = getPaymentStatusAndRefund({
        totalAmount: Math.round(Math.abs(Number(totalAmount))),
        amountPaid: Math.round(amountPaid),
        returnableAmount: Math.round(Number(returnableAmount ?? 0)),
      });
      await dispatch(
        updateBalanceDueAndStatusByPaymentId({
          paymentId,
          data: {
            status: payDetails?.status,
            balanceDue: payDetails?.balanceDueAfterReturn,
          },
        }),
      );
    }
    return true;
  };

  const onConfirmDecision = async () => {
    const remarks = (decisionRemarks ?? "").trim();
    if (!remarks) {
      setDecisionRemarksErr("Remark is required");
      return;
    }

    const approvalId = decisionItem?.approvalId;
    if (!approvalId) {
      dispatch(
        showSnackBar({
          message: "Approval id not found",
          type: "error",
        }),
      );
      return;
    }

    const isRefundRequest = REFUND_REQUEST_TYPES.includes(
      decisionItem?.requestType,
    );
    if (
      decisionType === "approve" &&
      isRefundRequest &&
      !decisionItem?.returnId
    ) {
      dispatch(
        showSnackBar({
          message: "Return id not found",
          type: "error",
        }),
      );
      return;
    }

    if (decisionType === "approve") {
      if (
        decisionItem?.requestType === "SERVICE_NEW" &&
        decisionItem?.serviceId
      ) {
        const statusRes = await dispatch(
          updateClinicServiceStatusById({
            serviceId: decisionItem.serviceId,
            status: true,
          }),
        );
        if (!updateClinicServiceStatusById.fulfilled.match(statusRes)) return;
      }

      if (
        decisionItem?.requestType === "SERVICE_NEW_VARIANT" &&
        decisionItem?.serviceId &&
        decisionItem?.referenceId
      ) {
        const statusRes = await dispatch(
          updateClinicServiceVariantApproved({
            serviceId: decisionItem.serviceId,
            variantId: decisionItem.referenceId,
            approved: true,
          }),
        );
        if (!updateClinicServiceVariantApproved.fulfilled.match(statusRes))
          return;
        const serviceData =
          readMandateSession()?.dataSharing?.serviceData ?? true;
        const serRes = await dispatch(
          getServicesWoLoader(`?serviceData=${serviceData}`),
        );
        if (serRes?.payload) {
          patchMandateSession({
            services: serRes?.payload?.data ?? [],
          });
        }
      }

      if (
        decisionItem?.requestType === "INVENTORY_NEW" &&
        decisionItem?.stockId
      ) {
        const statusRes = await dispatch(
          updateClinicStockStatusById({
            stockId: decisionItem.stockId,
            status: true,
          }),
        );
        if (!updateClinicStockStatusById.fulfilled.match(statusRes)) return;
      }

      if (
        decisionItem?.requestType === "INVENTORY_NEW_BATCH" &&
        decisionItem?.stockId &&
        decisionItem?.referenceId
      ) {
        const statusRes = await dispatch(
          updateClinicStockBatchApproved({
            stockId: decisionItem.stockId,
            batchId: decisionItem.referenceId,
            approved: true,
          }),
        );
        if (!updateClinicStockBatchApproved.fulfilled.match(statusRes)) return;
        const inventryData =
          readMandateSession()?.dataSharing?.inventryData ?? true;
        const stcRes = await dispatch(
          getClinicStocksWoLoader(`?inventryData=${inventryData}`),
        );
        if (stcRes?.payload) {
          patchMandateSession({
            stocks: stcRes?.payload?.data ?? [],
          });
        }
      }
    }

    if (decisionItem?.requestType === COUNT_CORRECTION_TYPE) {
      const adjustId = decisionItem?.adjustId ?? decisionItem?.referenceId;
      if (!adjustId) {
        dispatch(
          showSnackBar({
            message: "Adjustment id not found",
            type: "error",
          }),
        );
        return;
      }
      const stockRes = await dispatch(
        approveStockAdjustment({
          adjustId,
          approve: decisionType === "approve" ? "Y" : "N",
          rejectReason: decisionType === "reject" ? remarks : "",
          skipSuccessToast: true,
        }),
      );
      if (!approveStockAdjustment.fulfilled.match(stockRes)) return;
    }

    if (STOCK_TRANSFER_TYPES.includes(decisionItem?.requestType)) {
      const issueId = decisionItem?.issueId ?? decisionItem?.referenceId;
      if (!issueId) {
        dispatch(
          showSnackBar({
            message: "Issue id not found",
            type: "error",
          }),
        );
        return;
      }
      const stockRes = await dispatch(
        approveStockIssueRequest({
          issueId,
          approve: decisionType === "approve",
          rejectReason: decisionType === "reject" ? remarks : "",
          skipSuccessToast: true,
        }),
      );
      if (!approveStockIssueRequest.fulfilled.match(stockRes)) return;
    }

    if (decisionItem?.requestType === "PURCHASE_ORDER") {
      const detailId = decisionItem?.referenceId;
      if (!detailId) {
        dispatch(
          showSnackBar({
            message: "Purchase order id not found",
            type: "error",
          }),
        );
        return;
      }
      const poRes = await dispatch(
        updatePurchaseOrderCreditSave({
          detailId,
          creditSave: decisionType === "approve" ? "Submitted" : "Rejected",
        }),
      );
      if (!updatePurchaseOrderCreditSave.fulfilled.match(poRes)) return;
    }

    if (decisionType === "approve") {
      const result = await dispatch(
        approveApprovalRequest({ approvalId, remarks }),
      );
      if (!approveApprovalRequest.fulfilled.match(result)) return;
      if (isRefundRequest) {
        await completeApprovedRefund(decisionItem);
      }

      if (decisionItem?.requestType === "EDIT_CONSULT") {
        const appointmentId =
          decisionItem?.appointmentId ?? decisionItem?.referenceId ?? null;
        if (appointmentId) {
          const unlockRes = await dispatch(
            lockUnlockAppointmentById({
              id: appointmentId,
              url: "?lock=false",
            }),
          );
          if (!unlockRes?.payload) return;
        }
      }
    }

    if (decisionType === "reject") {
      const result = await dispatch(
        rejectApprovalRequest({ approvalId, remarks }),
      );
      if (!rejectApprovalRequest.fulfilled.match(result)) return;
      if (decisionItem?.requestType === "REFUND" && decisionItem?.returnId) {
        await dispatch(
          deleteReturnPaymentById({
            id: decisionItem.returnId,
            silent: true,
          }),
        );
      }
      if (decisionItem?.requestType === "REFUND" && decisionItem?.referenceId) {
        await dispatch(updatePaymentReturnedWoLoader(decisionItem.referenceId));
      }
    }

    onCloseDecisionMod();
    handleCloseViewModal();
    dispatch(getApprovals({ silent: true }));
  };

  const onNavigateEditConsult = (row) => {
    const appointmentId = row?.appointmentId ?? row?.referenceId ?? null;
    if (!appointmentId) {
      dispatch(
        showSnackBar({
          message: "Appointment id not found",
          type: "error",
        }),
      );
      return;
    }
    navigate(`/clinic-pet-details`, {
      state: {
        appointment: {
          appoinment: {
            appointmentId,
            petId: row?.petId ?? null,
            userId: row?.userId ?? null,
          },
        },
        selectedTab: "patientWorkbook",
      },
    });
  };

  const formattedDatas = filteredRaw.map((row) => {
    const isPending = row.category === "pending";
    const canDecide = canDecideRow(row);
    const isApprovedEditConsult =
      row.requestType === "EDIT_CONSULT" &&
      String(row.statusText || "").toLowerCase() === "approved";
    return {
      priority: (
        <span className={`app-priority-badge ${row.priorityClass}`}>
          {row.priorityText}
        </span>
      ),
      type: row.type,
      requester: row.requester,
      summary: row.summary,
      status: (
        <span className={`app-status-badge ${row.statusClass}`}>
          {row.statusText}
        </span>
      ),
      approvalStep: (
        <div>
          <div className="app-step-primary">{row.stepPrimary}</div>
          {row.stepSecondary ? (
            <div className="app-step-secondary">{row.stepSecondary}</div>
          ) : null}
        </div>
      ),
      submitted: row.submitted,
      approvedBy: row.approvedBy || "—",
      actions: (
        <div className="flex-row flex-ali-cen gap8">
          {isPending && canDecide ? (
            <>
              <div>
                <CustomButton
                  text="Approve"
                  smallBtn
                  onClick={() => openDecisionModal(row, "approve")}
                />
              </div>
              <div>
                <CustomButton
                  text="Reject"
                  smallBtn
                  redBtn
                  onClick={() => openDecisionModal(row, "reject")}
                />
              </div>
            </>
          ) : null}
          {isApprovedEditConsult ? (
            <div>
              <CustomButton
                text="Edit Consult"
                smallBtn
                onClick={() => onNavigateEditConsult(row)}
              />
            </div>
          ) : null}
          <div>
            <CustomButton
              text="View"
              smallBtn
              whiteBtn
              onClick={() => handleOpenViewModal(row)}
            />
          </div>
        </div>
      ),
    };
  });

  const viewIsPending = selectedViewItem?.category === "pending";
  const viewCanDecide = canDecideRow(selectedViewItem);
  const viewRequestType = selectedViewItem?.requestType;
  const viewIsApprovedEditConsult =
    viewRequestType === "EDIT_CONSULT" &&
    String(selectedViewItem?.statusText || "").toLowerCase() === "approved";

  return (
    <div className="appointments-tab-page">
      <TopBar sx={{ py: 1, minHeight: "unset" }}>
        <Container maxWidth="xl">
          <div className="flex-row-between-align-center flex-wrap gap12">
            <div className="flex-row-ali-cen gap8">
              <div className="ph5pv3">
                <CustomButton
                  text={`Pending approval (${pendingCount})`}
                  tabSelectdBtn={activeSubFilter === "pending"}
                  textBtn={activeSubFilter !== "pending"}
                  onClick={() => handleSubFilterChange("pending")}
                />
              </div>
              <div className="ph5pv3">
                <CustomButton
                  text="All requests"
                  tabSelectdBtn={activeSubFilter === "my_requests"}
                  textBtn={activeSubFilter !== "my_requests"}
                  onClick={() => handleSubFilterChange("my_requests")}
                />
              </div>
            </div>

            <div className="app-actions-bar mt5">
              <div className="app-inline-filter">
                <Select
                  list={filterRequestTypeOptions}
                  value={filterRequestType}
                  handleChange={(e) => setFilterRequestType(e?.target?.value)}
                  select
                  label="Type"
                />
              </div>
              {activeSubFilter === "my_requests" ? (
                <div className="app-inline-filter">
                  <Select
                    list={filterRequestStatusOptions}
                    value={filterRequestStatus}
                    handleChange={(e) =>
                      setFilterRequestStatus(e?.target?.value)
                    }
                    select
                    label="Status"
                  />
                </div>
              ) : null}

              {/* <div className="app-btn-nowrap">
                <CustomButton
                  text="+ New Request"
                  startIcon={<AddIcon sx={{ fontSize: 18 }} />}
                  onClick={handleOpenModal}
                />
              </div> */}
            </div>
          </div>
        </Container>
      </TopBar>

      <ReportTable
        columns={tableHeaders}
        datas={formattedDatas}
        maxHeight="70vh"
      />

      <CustomModal
        open={isModalOpen}
        onClose={handleCloseModal}
        header="Create request"
        rightModal
        modalWidth={32}
        headerBold
      >
        <Grid container spacing={2} className="ph20 scroll-80vh pt10">
          <Grid item xs={12}>
            <div className="txt-semi-bold fs14 light-grey mb5">
              Request type <span className="red-color">*</span>
            </div>
            <Select
              list={requestTypeOptions}
              value={formValues.requestType}
              handleChange={(e) =>
                handleFormChange("requestType", e?.target?.value)
              }
              select
            />
            {formErrors.requestType && (
              <Typography color="error" className="fs12 mt5">
                {formErrors.requestType}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12}>
            <div className="txt-semi-bold fs14 light-grey mb5">
              Priority <span className="red-color">*</span>
            </div>
            <Select
              list={priorityOptions}
              value={formValues.priority}
              handleChange={(e) =>
                handleFormChange("priority", e?.target?.value)
              }
              select
            />
          </Grid>

          <Grid item xs={12}>
            <div className="txt-semi-bold fs14 light-grey mb5">
              Summary <span className="red-color">*</span>
            </div>
            <CustomTextField
              placeholder="Short description of the request"
              fullWidth
              value={formValues.summary}
              handleChange={(e) =>
                handleFormChange("summary", e?.target?.value)
              }
            />
            {formErrors.summary && (
              <Typography color="error" className="fs12 mt5">
                {formErrors.summary}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12}>
            <div className="txt-semi-bold fs14 light-grey mb5">
              Notes (optional)
            </div>
            <CustomTextField
              placeholder="Additional context for approvers"
              fullWidth
              multiline
              rows={3}
              value={formValues.notes}
              handleChange={(e) => handleFormChange("notes", e?.target?.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography className="fs12 card-gray-color italic mt5">
              Fields above match what appears on the requests dashboard (cards
              and table).
            </Typography>
          </Grid>

          <Grid item xs={12} className="flex-row flex1-end gap12 mt20 mb20">
            <CustomButton text="Cancel" grayBtn onClick={handleCloseModal} />
            <CustomButton text="Submit request" onClick={handleSubmitRequest} />
          </Grid>
        </Grid>
      </CustomModal>

      <CustomModal
        open={isViewModalOpen}
        onClose={handleCloseViewModal}
        header={`${selectedViewItem?.type || "Request"} Details`}
        rightModal
        modalWidth={36}
        headerBold
      >
        <Grid container spacing={2} className="ph20 scroll-80vh pt10">
          <Grid item xs={12}>
            <Typography className="fs12 font-bold card-gray-color uppercase tracking-wider mb5">
              REQUEST TYPE
            </Typography>
            <Typography className="fs14 font-semibold black-color">
              {selectedViewItem?.type || "—"}
              {viewRequestType ? ` (${viewRequestType})` : ""}
            </Typography>
          </Grid>

          <Grid item xs={12} className="mt10">
            <Typography className="fs12 font-bold card-gray-color uppercase tracking-wider mb8">
              REQUESTER
            </Typography>
            <div className="flex-row flex-ali-cen gap12">
              <div className="app-avatar-circle">
                {getRequesterInitials(selectedViewItem?.requester)}
              </div>
              <div>
                <div className="fs15 font-bold black-color">
                  {selectedViewItem?.requester || "—"}
                </div>
                <div className="fs12 card-gray-color">
                  {selectedViewItem?.requesterRole || "—"}
                </div>
              </div>
            </div>
          </Grid>

          <Grid item xs={12} className="mt10">
            <Typography className="fs12 font-bold card-gray-color uppercase tracking-wider mb8">
              REQUEST DETAILS
            </Typography>
            <div className="app-details-box">
              <div className="app-details-row">
                <span className="app-details-label">Summary:</span>
                <span className="app-details-value">
                  {selectedViewItem?.summary || "—"}
                </span>
              </div>
              <div className="app-details-row">
                <span className="app-details-label">Name:</span>
                <span className="app-details-value">
                  {selectedViewItem?.referenceNo || "—"}
                </span>
              </div>
              {viewRequestType === "SERVICE_NEW_VARIANT" ? (
                <div className="app-details-row">
                  <span className="app-details-label">Package Price:</span>
                  <span className="app-details-value">
                    {selectedViewItem?.amount != null
                      ? `₹${Number(selectedViewItem.amount).toFixed(2)}`
                      : "—"}
                  </span>
                </div>
              ) : null}
              {viewRequestType === "INVENTORY_NEW_BATCH" ? (
                <>
                  <div className="app-details-row">
                    <span className="app-details-label">Batch Number:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.summary || "—"}
                    </span>
                  </div>
                  <div className="app-details-row">
                    <span className="app-details-label">Quantity:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.quantity != null
                        ? selectedViewItem.quantity
                        : "—"}
                    </span>
                  </div>
                  <div className="app-details-row">
                    <span className="app-details-label">Selling Price:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.amount != null
                        ? `₹${Number(selectedViewItem.amount).toFixed(2)}`
                        : "—"}
                    </span>
                  </div>
                </>
              ) : null}
              {viewRequestType === "EDIT_CONSULT" ? (
                <div className="app-details-row">
                  <span className="app-details-label">Sections to Edit:</span>
                  <span className="app-details-value">
                    {selectedViewItem?.editRequestFor || "—"}
                  </span>
                </div>
              ) : null}
              {viewRequestType === "COUNT_CORRECTION" ? (
                <div className="app-details-row">
                  <span className="app-details-label">Adjusted Qty:</span>
                  <span className="app-details-value">
                    {selectedViewItem?.noOfItems != null
                      ? selectedViewItem.noOfItems
                      : selectedViewItem?.amount != null
                        ? selectedViewItem.amount
                        : "—"}
                  </span>
                </div>
              ) : null}
              {viewRequestType === "INTERNAL_TRANSFER" ||
              viewRequestType === "EXTERNAL_TRANSFER" ? (
                <div className="app-details-row">
                  <span className="app-details-label">Requested Quantity:</span>
                  <span className="app-details-value">
                    {selectedViewItem?.quantity != null
                      ? selectedViewItem.quantity
                      : selectedViewItem?.amount != null
                        ? selectedViewItem.amount
                        : "—"}
                  </span>
                </div>
              ) : null}
              {viewRequestType === "PURCHASE_ORDER" ? (
                <>
                  <div className="app-details-row">
                    <span className="app-details-label">Supplier Name:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.supplierName || "—"}
                    </span>
                  </div>
                  <div className="app-details-row">
                    <span className="app-details-label">No of Items:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.noOfItems != null
                        ? selectedViewItem.noOfItems
                        : "—"}
                    </span>
                  </div>
                  <div className="app-details-row">
                    <span className="app-details-label">Total quantity:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.quantity != null
                        ? selectedViewItem.quantity
                        : "—"}
                    </span>
                  </div>
                  <div className="app-details-row">
                    <span className="app-details-label">Date:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.invoiceDate
                        ? moment(selectedViewItem.invoiceDate).format(
                            "DD MMM YYYY",
                          )
                        : "—"}
                    </span>
                  </div>
                </>
              ) : null}
              {viewRequestType === "REFUND" ? (
                <>
                  <div className="app-details-row">
                    <span className="app-details-label">Pet Name:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.petName || "—"}
                    </span>
                  </div>
                  <div className="app-details-row">
                    <span className="app-details-label">Customer Name:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.customerName || "—"}
                    </span>
                  </div>
                  <div className="app-details-row">
                    <span className="app-details-label">Refund Amount:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.refundAmount != null
                        ? `₹${Number(selectedViewItem.refundAmount).toFixed(2)}`
                        : "—"}
                    </span>
                  </div>
                  <div className="app-details-row">
                    <span className="app-details-label">Invoice Number:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.invoiceNumber || "—"}
                    </span>
                  </div>
                  <div className="app-details-row">
                    <span className="app-details-label">Invoice Date:</span>
                    <span className="app-details-value">
                      {selectedViewItem?.invoiceDate
                        ? moment(selectedViewItem.invoiceDate).format(
                            "DD MMM YYYY",
                          )
                        : "—"}
                    </span>
                  </div>
                </>
              ) : null}
              {/* <div className="app-details-row">
                <span className="app-details-label">Amount:</span>
                <span className="app-details-value">
                  {selectedViewItem?.amount != null
                    ? `₹${Number(selectedViewItem.amount).toFixed(2)}`
                    : "—"}
                </span>
              </div> */}
              {/* {viewRequestType === "SERVICE_NEW" ? (
                <div className="app-details-row">
                  <span className="app-details-label">Service ID:</span>
                  <span className="app-details-value">
                    {selectedViewItem?.serviceId || "—"}
                  </span>
                </div>
              ) : null}
              {viewRequestType === "INVENTORY_NEW" ? (
                <div className="app-details-row">
                  <span className="app-details-label">Stock ID:</span>
                  <span className="app-details-value">
                    {selectedViewItem?.stockId || "—"}
                  </span>
                </div>
              ) : null} */}
              <div className="app-details-row">
                <span className="app-details-label">Status:</span>
                <span className="app-details-value">
                  {selectedViewItem?.statusText || "—"}
                </span>
              </div>
              {selectedViewItem?.rejectRemarks ? (
                <div className="app-details-row">
                  <span className="app-details-label">Reject remarks:</span>
                  <span className="app-details-value">
                    {selectedViewItem.rejectRemarks}
                  </span>
                </div>
              ) : null}
            </div>
          </Grid>

          <Grid item xs={12} className="mt15">
            <Typography className="fs12 font-bold card-gray-color uppercase tracking-wider mb8">
              APPROVAL STEP
            </Typography>
            <div className="app-details-box">
              <div className="fs13 black-color">
                {selectedViewItem?.approvalStep || "—"}
              </div>
            </div>
          </Grid>

          {viewIsPending && viewCanDecide ? (
            <Grid item xs={12} className="mt20 mb20">
              <div className="flex-row gap10">
                <div className="flex1">
                  <div>
                    <CustomButton
                      text="Reject"
                      redBtn
                      fullWidth
                      onClick={() =>
                        openDecisionModal(selectedViewItem, "reject")
                      }
                      smallBtn
                    />
                  </div>
                </div>
                <div className="flex1">
                  <div>
                    <CustomButton
                      text="Approve"
                      fullWidth
                      onClick={() =>
                        openDecisionModal(selectedViewItem, "approve")
                      }
                      smallBtn
                    />
                  </div>
                </div>
              </div>
            </Grid>
          ) : (
            <Grid item xs={12} className="mt20 mb20">
              {viewIsApprovedEditConsult ? (
                <div className="flex-row gap10">
                  <div className="flex1">
                    <CustomButton
                      text="Close"
                      grayBtn
                      fullWidth
                      onClick={handleCloseViewModal}
                      smallBtn
                    />
                  </div>
                  <div className="flex1">
                    <CustomButton
                      text="Edit Consult"
                      fullWidth
                      onClick={() => onNavigateEditConsult(selectedViewItem)}
                      smallBtn
                    />
                  </div>
                </div>
              ) : (
                <CustomButton
                  text="Close"
                  grayBtn
                  fullWidth
                  onClick={handleCloseViewModal}
                />
              )}
            </Grid>
          )}
        </Grid>
      </CustomModal>

      <CustomModal
        open={decisionModVsble}
        onClose={onCloseDecisionMod}
        header={
          decisionType === "reject" ? "Reject request" : "Approve request"
        }
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10 mb10">
          {decisionType === "reject"
            ? "Are you sure you want to reject this request?"
            : "Are you sure you want to approve this request?"}
        </Typography>
        <div className="ml10 mr10 mb10">
          <CustomTextField
            label="Remark"
            fullWidth
            multiline
            rows={3}
            value={decisionRemarks}
            handleChange={(e) => {
              setDecisionRemarks(e?.target?.value ?? "");
              if (decisionRemarksErr) setDecisionRemarksErr("");
            }}
            error={!!decisionRemarksErr}
            helperText={decisionRemarksErr}
          />
        </div>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-center mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                smallBtn
                redBtn={decisionType === "reject"}
                onClick={onConfirmDecision}
              />
            </div>
            <div className="ml10">
              <CustomButton
                text="No"
                onClick={onCloseDecisionMod}
                smallBtn
                redBtn={decisionType !== "reject"}
              />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </div>
  );
};

export default AppointmentsTab;
